import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "@modules/core";

@Component({
  selector: "app-register-login-oidc",
  templateUrl: "./register-login-oidc.component.html",
  styleUrls: ["./register-login-oidc.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RegisterLoginOidcComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.authService.setIsOnboarding(true);
    this.authService.loginWithoutPrompt();
  }
}
